import { render, staticRenderFns } from "./Shph.vue?vue&type=template&id=2570bbef&scoped=true&"
import script from "./Shph.vue?vue&type=script&lang=js&"
export * from "./Shph.vue?vue&type=script&lang=js&"
import style0 from "./Shph.vue?vue&type=style&index=0&id=2570bbef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570bbef",
  null
  
)

export default component.exports